<template>
  <router-view />
</template>

<script>
export default {
  name: 'AdministrativeIndex'
}
</script>
